import { createContext, useContext } from "react";

export const MarketingContext = createContext({
  enabled: false,
  getBannersForPlacement: () => [],
  recordBannerImpression: () => {},
  dismissBanner: () => {},
  handleCreativeClick: () => {},
  notifySlotVisible: () => {},
});

export const useMarketing = () => useContext(MarketingContext);
